<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="w-75 m-auto">
                            <img class="img-fluid rounded-circle" src="../../../../../../assets/images/warehouse.png">
                        </div>
                    </div>
                    <div class="card-body mt-0 p-t-0 p-b-0">
                        <hr class="m-t-0">
                        <h5 class="mb-0">{{warehouse.name}}</h5>
                        <span class="" v-html="warehouse.description"/>
                        <hr>
                        <address class="mt-2">
                            <strong><i class="fas fa-map-marked-alt"/></strong><br>
                            {{warehouse.address.line1}}<br>
                            <span v-if="warehouse.address.line2">{{warehouse.address.line2}}<br></span>
                            {{warehouse.address.city}}, {{warehouse.address.state}}<br>
                            {{warehouse.address.postal_code}}, {{warehouse.address.country}}<br>
                        </address>
                    </div>
                    <div class="card-footer p-t-0 p-b-0 mb-3">
                        <hr class="m-t-0">
                        <div v-if="currentOrg.role === 'ORG_ADMIN'">
                            <router-link :to="{ name: 'editmarketplacewarehouse', params: {warehouseid: warehouseid}}"
                                         class="btn btn-info ml-auto">Edit
                            </router-link>

                            <button class="btn btn-secondary float-right">Delete</button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-9">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-blue">
                            <div class="card-header">
                                <h4 class="card-title">Deduct stock from Warehouse</h4>
                            </div>
                            <form @submit.prevent="handleSubmitDed">
                                <div class="card-body">

                                    <div class="form-group row">
                                        <label class="col-sm-3 text-right control-label col-form-label">Good</label>
                                        <div class="col-sm-7 mt-2" v-if="!dedGood.good">
                                            <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                               href="javascript:void(0)"><b>Click here to
                                                add commodity</b></a>
                                        </div>
                                        <div class="col-sm-7" v-else>
                                            <p data-target="#searchAndSelectCommodityModal" data-toggle="modal" class="form-control">{{dedGood.good.name}}
                                                <span>({{dedGood.good.code}})</span> -{{dedGood.good.variety}}</p>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 text-right control-label col-form-label">Quantity</label>
                                        <div class="col-sm-7">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                                       class="form-control"
                                                       data-vv-as="Quantity"
                                                       id="quantity3"
                                                       name="quantity"
                                                       placeholder="Quantity"
                                                       step="any"
                                                       type="number"
                                                       v-model="dedGood.quantity"
                                                       v-validate="'required',`between:0,${dedGood.limit}`">
                                                <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                                       :value="dedGood.unit" class="form-control" disabled
                                                       style="max-width: 40px">
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('quantity')">{{ errors.first('quantity')
                                                }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 text-right control-label col-form-label">Remarks</label>
                                        <div class="col-sm-7">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('ref')}"
                                                       class="form-control"
                                                       data-vv-as="Remarks"
                                                       id="ref3"
                                                       name="ref"
                                                       placeholder="Remarks"
                                                       type="text"
                                                       v-model="dedGood.ref"
                                                       v-validate="'required'">
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('ref')">{{ errors.first('ref') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="form-group m-b-0 text-right">
                                        <div class="button-group">
                                            <button class="btn waves-effect waves-light btn-success" type="submit">
                                                Save
                                            </button>
                                            <button class="btn waves-effect waves-light btn-secondary" type="reset">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds" :pre-commodities="warehouse.inventory"
                                 :single-select="true"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import SearchSelectCommodity from "../../../../common/SearchSelectCommodity";
    import Multiselect from "vue-multiselect";
    import {mapGetters} from "vuex";

    export default {
        name: "DeductCommodityFromWarehouse",
        components: {SearchSelectCommodity, Multiselect},
        props: ["marketplaceid", "warehouseid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                warehouses: [],
                warehouse: {
                    name: null,
                    description: null,
                    address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null
                    },
                    inventory: [],
                },
                dedGood: {
                    good: null,
                    quantity: null,
                    unit: null,
                    ref: null,
                    limit: 0
                },
                commodityIds: [],
                logs_by_good: [],
                logs_by_good_bkp: [],
                batches: [],
                selected_batch: null
            }
        },
        mounted() {
            this.getWareHouse();
        },
        methods: {
            async getWareHouse() {
                let reply = await this.$http.get(`/marketplaces/${this.marketplaceid}/warehouses/${this.warehouseid}`);
                this.warehouse = reply.data;
            },
            async searchWareHouses(search) {
                let reply = await this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                        params: {
                            search
                        }
                    });
                this.warehouses = _.filter(reply.data.warehouses, (w) => {
                    return w.id !== Number(this.warehouseid)
                });
            },
            handleSubmitDed() {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        console.log(valid)
                        if (valid) {
                            this.deductGoodFromWarehouse();
                        }
                    });
            },
            async deductGoodFromWarehouse() {
                console.log("reqbody", this.dedGood);
                try {
                    let payload = {
                        commodity_id: this.dedGood.good.id,
                        quantity: this.dedGood.quantity,
                        unit_id: this.dedGood.good.unit_id,
                        ref: this.dedGood.ref
                    }
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/deduct`, payload)
                    await this.$router.push({name: 'viewmarketplacewarehouse'});
                    this.$toastr('success', 'Good deducted from warehouse', 'Success');
                } catch (e) {
                    console.log(e);
                    this.$toastr('error', 'Could not deduct stock to warehouse', 'Failed');
                } finally {
                    $('#deductGoodModal').modal('hide')
                }
            },
            setCommodity(e) {
                let commodity = e.length > 0 ? e[0] : null;
                if (commodity) {
                    this.dedGood.unit = commodity.unit;
                    this.dedGood.good = commodity;
                    this.dedGood.limit = this.dedGood.good ? Number(this.dedGood.good.stock) : 0;
                    this.commodityIds = [commodity.id];
                }

            }
        }
    }
</script>

<style scoped>

</style>
